import React, { Component } from 'react';
import './Footer.css';

const JOBS_URL = 'https://www.snap.com/en-US/jobs/?locations=Toronto';
const PRESS_URL = 'mailto:media@bitstrips.com';
const TERMS_URL = 'https://www.bitmoji.com/support/terms.html';
const PRIVACY_URL = 'https://www.snap.com/privacy/privacy-policy/';
const SUPPORT_URL = 'https://support.bitmoji.com/';

class Footer extends Component {
    render() {
        return (
            <footer className="footer-bottom-bar" id="bitmoji-footer">
                <a href="/"> Home </a> &middot;
                <a href={JOBS_URL}> Careers </a> &middot;
                <a href={PRESS_URL}> Press </a> &middot;
                <a href={TERMS_URL}> Terms </a> &middot;
                <a href={PRIVACY_URL}> Privacy </a>  &middot;
                <a href={SUPPORT_URL}> Support </a>
                <div className="copyright"><p>© 2018 Bitstrips Inc.</p></div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js